// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".drag-fixed[data-v-7e917494]{position:fixed;z-index:1;display:inline-block;min-width:.48rem;min-height:.48rem}.drag-fixed.done[data-v-7e917494],.drag-fixed.done-right[data-v-7e917494]{transition:.5s}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
